import { render, staticRenderFns } from "./ItemGallery.vue?vue&type=template&id=2bf9f904"
import script from "./ItemGallery.vue?vue&type=script&lang=js"
export * from "./ItemGallery.vue?vue&type=script&lang=js"
import style0 from "./ItemGallery.vue?vue&type=style&index=0&id=2bf9f904&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports